import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import { fallbackInternalPath, resolveTargetUrl } from '../../forum/utils/resolveTargetUrl';
const MS_PER_DAY = 24 * 60 * 60 * 1000;
function normalizeUrl(url) {
  const u = (url || '').trim();
  return u;
}
function isExternal(url) {
  return /^https?:\/\//i.test(url);
}
function startOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}
function parseYmdLocal(ymd) {
  // Expect YYYY-MM-DD
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((ymd || '').trim());
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const da = Number(m[3]);
  const dt = new Date(y, mo, da, 0, 0, 0, 0);
  // basic sanity: JS date can overflow; verify
  if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== da) return null;
  return dt;
}
function daysRemaining(releaseDateYmd) {
  const target = parseYmdLocal(releaseDateYmd);
  if (!target) return null;
  const today0 = startOfLocalDay(new Date()).getTime();
  const target0 = startOfLocalDay(target).getTime();

  // Ceil for future dates so "tomorrow" => 1
  return Math.ceil((target0 - today0) / MS_PER_DAY);
}
function applyTemplate(tpl, days) {
  const t = (tpl || '').trim() || '{{days}} nap múlva';
  return t.replace(/\{\{\s*days\s*\}\}/g, String(days));
}
function requestRedraw() {
  if (typeof m !== 'undefined' && typeof m.redraw === 'function') {
    m.redraw();
    return;
  }
  app.redraw();
}
export default class UbuntuReleaseCountdownWidget extends Widget {
  constructor() {
    super(...arguments);
    _defineProperty(this, "resolvedRef", null);
    _defineProperty(this, "resolvedHref", '');
    _defineProperty(this, "resolvingRef", null);
  }
  className() {
    return 'UbhuUbuntuCountdownWidget';
  }
  icon() {
    return 'fab fa-ubuntu';
  }
  title() {
    // cím nélkül, hogy tényleg "banner" legyen
    return '';
  }
  resolveHref(ref) {
    const normalized = normalizeUrl(ref);
    if (!normalized) {
      this.resolvedRef = normalized;
      this.resolvedHref = '';
      this.resolvingRef = null;
      return;
    }
    if (this.resolvedRef === normalized || this.resolvingRef === normalized) {
      return;
    }
    if (isExternal(normalized)) {
      this.resolvedRef = normalized;
      this.resolvedHref = normalized;
      this.resolvingRef = null;
      return;
    }
    this.resolvedRef = normalized;
    this.resolvedHref = fallbackInternalPath(normalized);
    this.resolvingRef = normalized;
    void resolveTargetUrl(normalized).then(href => {
      if (this.resolvingRef !== normalized) return;
      this.resolvedHref = href || '';
      this.resolvingRef = null;
      requestRedraw();
    }).catch(() => {
      if (this.resolvingRef !== normalized) return;
      this.resolvedHref = fallbackInternalPath(normalized);
      this.resolvingRef = null;
      requestRedraw();
    });
  }
  content() {
    const releaseDate = app.forum.attribute('ubhuUbuntuCountdownReleaseDate');
    const releasedRaw = app.forum.attribute('ubhuUbuntuCountdownReleased');
    const released = releasedRaw === true || releasedRaw === 1 || releasedRaw === '1' || releasedRaw === 'true' || releasedRaw === 'yes' || releasedRaw === 'on';
    const backgroundUrl = app.forum.attribute('ubhuUbuntuCountdownBackgroundUrl');
    const preLink = app.forum.attribute('ubhuUbuntuCountdownPreLink');
    const postLink = app.forum.attribute('ubhuUbuntuCountdownPostLink');
    const countdownTpl = app.forum.attribute('ubhuUbuntuCountdownCountdownTemplate');
    const soonText = app.forum.attribute('ubhuUbuntuCountdownSoonText');
    const releasedText = app.forum.attribute('ubhuUbuntuCountdownReleasedText');
    const labelCss = app.forum.attribute('ubhuUbuntuCountdownLabelCss');
    let label = '';
    let rawHref = '';
    let aria = '';
    if (released) {
      label = releasedText;
      rawHref = postLink || '';
      aria = "Ubuntu kiad\xE1s: ".concat(label);
    } else {
      const d = daysRemaining(releaseDate);
      if (d === null) {
        label = 'Nincs beállítva dátum';
        rawHref = preLink || '';
        aria = "Ubuntu kiad\xE1s: ".concat(label);
      } else if (d <= 0) {
        label = soonText;
        rawHref = preLink || '';
        aria = "Ubuntu kiad\xE1s: ".concat(label);
      } else {
        label = applyTemplate(countdownTpl, d);
        rawHref = preLink || '';
        aria = "Ubuntu kiad\xE1s: ".concat(label);
      }
    }
    const normalizedHref = normalizeUrl(rawHref);
    this.resolveHref(normalizedHref);
    const href = this.resolvedRef === normalizedHref ? this.resolvedHref : '';
    const styleBg = backgroundUrl ? {
      backgroundImage: "url(\"".concat(backgroundUrl, "\")")
    } : {};

    // Label CSS: deklarációk -> inline style tag, scope-olva a label elemre
    // (A felhasználó ide CSS deklarációkat írjon, nem teljes szelektort)
    const scopedCss = (labelCss || '').trim() ? ".UbhuUbuntuCountdownWidget .UbhuUbuntuCountdownWidget-label { ".concat(labelCss, " }") : '';
    const inner = m("div", {
      className: "UbhuUbuntuCountdownWidget-inner",
      role: "img",
      "aria-label": aria
    }, scopedCss ? m("style", null, scopedCss) : null, m("div", {
      className: "UbhuUbuntuCountdownWidget-hero",
      style: styleBg
    }), m("div", {
      className: "UbhuUbuntuCountdownWidget-label"
    }, label));
    if (href) {
      const attrs = {
        href,
        className: 'UbhuUbuntuCountdownWidget-link',
        'aria-label': aria
      };
      if (isExternal(href)) {
        attrs.target = '_blank';
        attrs.rel = 'noopener noreferrer';
      }
      return m("a", attrs, inner);
    }
    return m("div", {
      className: "UbhuUbuntuCountdownWidget-nolink"
    }, inner);
  }
}
flarum.reg.add('ubhu-ubuntu-release-countdown-widget', 'common/components/UbuntuReleaseCountdownWidget', UbuntuReleaseCountdownWidget);